<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Ordered From Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>Ordered To Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" />
      </div>
      <div class="col-2" style="margin-top: 3%;">
        <button mat-raised-button color="primary" (click)="serveDailySale()" class="button-class"
          style="font-size: 20px;" [disabled]="from_date == null || to_date == null">Get</button>
        <mat-spinner [diameter]="40" *ngIf="data_loading"></mat-spinner>
      </div>
      <div class="col-2" *ngIf="is_data_available">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i
            class="material-icons">
            get_app
          </i> Download Pdf</button>
      </div>
    </div>
  </div>
  <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file!== null"></iframe>
</section>
